import { NextRouter } from 'next/router';

import { SectionType } from '../constants';

type Section = {
  id: number;
  name: string;
};

type PathToNamespaceFunction = (router: NextRouter) => string;

const getCurationNamespace: PathToNamespaceFunction = (router) => {
  const title = router.query.title as string;

  let subSections: Section[] = [];

  try {
    subSections = JSON.parse(router.query.sub_sections as string) || [];
  } catch (error) {
    subSections = [];
  }
  let subSectionIndex = 0;
  try {
    subSectionIndex = parseInt(router.query.sub_section_index as string) || 0;
  } catch (err) {
    subSectionIndex = 0;
  }
  let sectionId = 0;
  try {
    sectionId = subSections.length
      ? subSections[subSectionIndex].id
      : parseInt(router.query.sectionId as string);
  } catch (err) {
    sectionId = 0;
  }

  const sectionType =
    (router.query.section_type as SectionType) ?? SectionType.original;

  if (subSections?.length) {
    const subSection = subSections?.find((s) => s.id === sectionId);
    if (subSection) {
      const { id, name } = subSection;
      const subPath = `${name}(${id})`.replace('/', '+');
      return sectionType === SectionType.standard
        ? `홈/스탠다드/${title}/더보기/${subPath}`
        : `홈/오리지널/${title}/더보기/${subPath}`;
    }
  }

  return sectionType === SectionType.standard
    ? `홈/스탠다드/${title}/더보기`
    : `홈/오리지널/${title}/더보기`;
};

const getSearchResultNamespace: PathToNamespaceFunction = (router) => {
  const tab = router.query.tab as string;

  switch (tab) {
    case 'story':
      return '검색결과/작품';
    case 'user':
      return '검색결과/작가';
    case 'tag':
      return '검색결과/태그';
    default:
      return '검색결과';
  }
};

const getSearchNamespace: PathToNamespaceFunction = (router) => {
  const tab = (router.query.tab as string) || 'recommend';
  if (tab === 'recommend') {
    return '검색/AI추천';
  }
  return `검색/카테고리(${tab})`;
};

const getLibraryNamespace: PathToNamespaceFunction = (router) => {
  const tab = (router.query.tab as string) || 'read-stories';

  switch (tab) {
    case 'following-feed':
      return '내서재/팔로잉';
    case 'liked-stories':
      return '내서재/좋아요';
    case 'chat-library':
      return '내서재/플레이';
    default:
      return '내서재/읽은작품';
  }
};

const getPlayNamespace: PathToNamespaceFunction = () => '플레이/캐릭터 상세';

const getUsersNamespace: PathToNamespaceFunction = () => '작가상세/작품';

const getStoryListByTagsNamespace: PathToNamespaceFunction = (router) => {
  const tab = (router.query.tab as string) || 'popular';
  return tab === 'popular'
    ? '작품상세/태그상세/인기작품'
    : '작품상세/태그상세/최신작품';
};

export const getPageNamespace = (router: NextRouter) => {
  const currentPath = router.asPath;

  const pathCheckers: {
    regex: RegExp;
    getNamespace: PathToNamespaceFunction;
  }[] = [
    { regex: /\/curations\/\d+/, getNamespace: getCurationNamespace },
    { regex: /\/search\/(.+)/, getNamespace: getSearchResultNamespace },
    { regex: /\/search/, getNamespace: getSearchNamespace },
    { regex: /\/library/, getNamespace: getLibraryNamespace },
    { regex: /\/play\/characters\/\d+/, getNamespace: getPlayNamespace },
    { regex: /\/users\/\d+/, getNamespace: getUsersNamespace },
    {
      regex: /\/tags\/\d+\/stories/,
      getNamespace: getStoryListByTagsNamespace,
    },
  ];

  const matchedPath = pathCheckers.find((pathChecker) => {
    return currentPath.match(pathChecker.regex);
  });

  return matchedPath?.getNamespace(router) ?? '기타페이지';
};
